import { useSelector } from "react-redux";

import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";

// defaultTheme
import themes from "./themes";

import NavigationScroll from "./layout/NavigationScroll";

import React, { lazy, useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import { authenticateSocket } from "./socket";
// import SimilarProducts from "./components/similarProducts/SimilarProduct.component";
import ProductMedia from "./components/products/MediaProduct.component";
import "./App.css";
import MainLayout from "./layout/MainLayout";

import Loadable from "./ui-component/Loadable";
import role_axios from "./views/utilities/rolesaxios.js";

// login option 3 routing
const AuthLogin3 = Loadable(
  lazy(() => import("./views/pages/authentication/authentication3/Login3"))
);
const Privacy3 = Loadable(
  lazy(() => import("./views/pages/authentication/authentication3/privacy"))
);
const Terms3 = Loadable(
  lazy(() => import("./views/pages/authentication/authentication3/terms"))
);
const AuthForgot3 = Loadable(
  lazy(() => import("./views/pages/authentication/authentication3/Forgot3"))
);
const AuthResetPassword = Loadable(
  lazy(() =>
    import("./views/pages/authentication/authentication3/ResetPassword3")
  )
);
const SelectEmp3 = Loadable(
  lazy(() => import("./views/pages/authentication/authentication3/SelectEmp3"))
);

const AccountSettings = Loadable(
  lazy(() => import("./views/account-settings"))
);

const DashboardDefault = Loadable(
  lazy(() => import("./views/dashboard/Default/index.js"))
);
const PopularCard = Loadable(
  lazy(() => import("./views/dashboard/Default/PopularCard.js"))
);
const Policies = Loadable(lazy(() => import("./views/policies")));
const PolicyAdd = Loadable(lazy(() => import("./views/policies/policyAdd")));
const PolicyEdit = Loadable(lazy(() => import("./views/policies/policyEdit")));

const CustomerPage = Loadable(lazy(() => import("./views/customer")));
// const CustomerEditPage = Loadable(lazy(() => import("./views/customer/edit")));

// const Privacy = Loadable(lazy(() => import("./public/PRIVACY_POLICY")));
// const Privacy2 = Loadable(lazy(() => import("./public/privacy")));
// const Terms = Loadable(lazy(() => import("./public/TERMS_AND_CONDITIONS")));
// const Terms2 = Loadable(lazy(() => import("./public/terms")));

const Products3 = Loadable(lazy(() => import("./views/products")));
const Products3Add = Loadable(lazy(() => import("./views/products/add")));
const Products3Edit = Loadable(lazy(() => import("./views/products/edit")));
const Products3Images = Loadable(lazy(() => import("./views/products/media")));
const Gallery = Loadable(lazy(() => import("./views/assets/Gallery")));
const ModernGallery = Loadable(
  lazy(() => import("./views/assets/modernGallery"))
);
const Brands3 = Loadable(lazy(() => import("./views/brands")));
const Brands3Add = Loadable(lazy(() => import("./views/brands/add")));
const Brands3Edit = Loadable(lazy(() => import("./views/brands/edit")));

const Category3 = Loadable(lazy(() => import("./views/category")));
const Category3Add = Loadable(lazy(() => import("./views/category/add")));
const Category3Edit = Loadable(lazy(() => import("./views/category/edit")));

const SubCategory3 = Loadable(lazy(() => import("./views/subCategory")));
const SubCategory3Add = Loadable(lazy(() => import("./views/subCategory/add")));
const SubCategory3Edit = Loadable(
  lazy(() => import("./views/subCategory/edit"))
);

const Stores3 = Loadable(lazy(() => import("./views/stores")));
const Stores3Map = Loadable(lazy(() => import("./views/stores/map")));
const Stores3Add = Loadable(lazy(() => import("./views/stores/add")));
const Stores3Edit = Loadable(lazy(() => import("./views/stores/edit")));

const StoresEmployee3 = Loadable(lazy(() => import("./views/stores/employee")));
const StoresEmployee3Add = Loadable(
  lazy(() => import("./views/stores/employee/add"))
);
const StoresEmployee3Edit = Loadable(
  lazy(() => import("./views/stores/employee/edit"))
);

const StoresProducts3 = Loadable(lazy(() => import("./views/stores/products")));
const StoresProducts3Add = Loadable(
  lazy(() => import("./views/stores/products/add"))
);
const StoresProducts3Edit = Loadable(
  lazy(() => import("./views/stores/products/edit"))
);

const History = Loadable(lazy(() => import("./views/history")));
const Details = Loadable(lazy(() => import("./views/details")));
const NotFound = Loadable(lazy(() => import("./views/error-pages/Error404")));
const Ticket = Loadable(lazy(() => import("./views/ticket")));
const Ticketview = Loadable(lazy(() => import("./views/ticketview")));
const Emailview = Loadable(lazy(() => import("./views/email")));
const AllEmployees = Loadable(lazy(() => import("./views/allemployees")));
// const Verification = Loadable(lazy(() => import("./views/verification")));

const OnlineHistory = Loadable(
  lazy(() => import("./views/onlinehistory/index.js"))
);
const Documenttype = Loadable(
  lazy(() => import("./views/document-type/add.js"))
);

const OpenHistory = Loadable(lazy(() => import("./views/openclose/index.js")));

const Pass00 = Loadable(lazy(() => import("./views/00pass")));

const StoreDetails = Loadable(
  lazy(() => import("./views/storedetails/index.js"))
);

const Rbackend = Loadable(lazy(() => import("./views/control/index.js")));

// const SocketExample = Loadable(lazy(() => import("./views/socket-example")));

// const SocketExamplenew1 = Loadable(
//   lazy(() => import("./views/socket-example/new1.js"))
// );
// const SocketExamplenew2 = Loadable(
//   lazy(() => import("./views/socket-example/new2.js"))
// );
// const SocketExamplefor1 = Loadable(
//   lazy(() => import("./views/socket-example/for3.js"))
// );

// const newChat = Loadable(lazy(() => import("./views/newChatJoy/index.tsx")));

function App() {
  window.alert = function () { };
  const customization = useSelector((state) => state.customization);

  const [loading, setLoading] = React.useState(false);


  useEffect(() => {
    const token = localStorage.getItem("token");
    const clientId = localStorage.getItem("clientId");
    if (token && clientId) authenticateSocket(token, clientId);
  }, []);

  const role_id = localStorage.getItem('roleId');
  const user = JSON.parse(localStorage.getItem('user') || "{}");
  const user_id = user.id;

  const fetchPermissionsOfRole = async (role_id) => {
    try {
      const response = await role_axios.get(`/roles/${role_id}`);
      if (response.data) {
        const accessPermissions = response.data.data.access;
        localStorage.setItem("allPermissions", JSON.stringify(accessPermissions));
      }
    } catch (error) {
      console.error("Error fetching permissions of role:", error);
    }
  };

  const fetchPermissionsOfUser = async (user_id) => {
    try {
      setLoading(true);
      const response = await role_axios.get(`/roles/user/${user_id}`);
      if (response.data) {
        let storedPermissions = JSON.parse(localStorage.getItem("allPermissions") || "[]");
        const newPermissions = response.data.data.access;
        storedPermissions.push(...newPermissions);
        localStorage.setItem("allPermissions", JSON.stringify(storedPermissions));
      }
    } catch (error) {
      console.error("Error fetching permissions of user:", error);
    } finally {
      setLoading(false);
    }
  };

  const saveUserPermission = async (role_id, user_id) => {
    try {
      await fetchPermissionsOfRole(role_id);
      await fetchPermissionsOfUser(user_id);
    } catch (error) {
      console.error("Error saving user permissions:", error);
    }
  };

  useEffect(() => {
    if (role_id && user_id) {
      saveUserPermission(role_id, user_id);
    }
  }, [role_id, user_id]);

  if (loading) return <div>Loading...</div>;



  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <NavigationScroll>
          <Routes>
            {/* <Redirect to="/login" /> */}
            <Route path="/" element={<AuthLogin3 />} />
            <Route path="/forgot" element={<AuthForgot3 />} />
            <Route path="/reset" element={<AuthResetPassword />} />
            <Route path="/selectemp" element={<SelectEmp3 />} />
            <Route path="/privacy" element={<Privacy3 />} />
            <Route path="/terms" element={<Terms3 />} />

            {/* <Route path="/main" element={<SideBar />}>
              <Route index element={<Dashboard />} />  
              <Route path="account-settings" element={<AccountSettings />} />
              <Route path="products" element={<Product />} />
              <Route path="products/media/:id" element={<ProductMedia />} />
              <Route path="brands" element={<Brand />} />
              <Route path="category" element={<Category />} />
              <Route path="subCategory" element={<SubCategory />} />
              <Route path="similarProducts" element={<SimilarProducts />} />
              <Route path="customer" element={<Customer />} />
              <Route path="store" element={<Store />} />
              <Route path="store/loc" element={<MapStore />} />
              <Route path="store/create" element={<StoreForm />} />
              <Route path="store/emp/:id" element={<StoreEmp />} />
              <Route path="store/product/:id" element={<StoreProduct />} />
            </Route> */}

            <Route path="/" element={<MainLayout />}>
              <Route path="dashboard" element={<DashboardDefault />} />
              <Route path="dashboard" element={<PopularCard />} />
              <Route path="account-settings" element={<AccountSettings />} />

              <Route path="products" element={<Products3 />} />
              <Route path="products/add/" element={<Products3Add />} />
              <Route
                path="products/edit/:productId"
                element={<Products3Edit />}
              />
              <Route path="products/media" element={<Products3Images />} />
              <Route path="products/uploadMedia" element={<Gallery />} />
              <Route path="ModernGallery" element={<ModernGallery />} />

              <Route path="brands" element={<Brands3 />} />
              <Route path="brands/add/" element={<Brands3Add />} />
              <Route path="brands/edit/:brandId" element={<Brands3Edit />} />

              <Route path="category" element={<Category3 />} />
              <Route path="category/add/" element={<Category3Add />} />
              <Route
                path="category/edit/:categoryId"
                element={<Category3Edit />}
              />

              <Route path="subCategory" element={<SubCategory3 />} />
              <Route path="subCategory/add/" element={<SubCategory3Add />} />
              <Route
                path="subCategory/edit/:subCategoryId"
                element={<SubCategory3Edit />}
              />

              <Route path="store" element={<Stores3 />} />
              <Route path="store/loc" element={<Stores3Map />} />
              <Route path="store/add/" element={<Stores3Add />} />
              <Route path="store/edit/" element={<Stores3Edit />} />
              <Route path="email" element={<Emailview />} />
              <Route path="store/emp/:id" element={<StoresEmployee3 />} />
              <Route
                path="store/emp/add/:id"
                element={<StoresEmployee3Add />}
              />
              <Route
                path="store/emp/edit/:id"
                element={<StoresEmployee3Edit />}
              />

              <Route path="store/product/:id" element={<StoresProducts3 />} />
              <Route
                path="store/product/add/"
                element={<StoresProducts3Add />}
              />
              <Route
                path="store/product/edit/:id"
                element={<StoresProducts3Edit />}
              />

              <Route path="policies" element={<Policies />} />
              <Route path="policies/add" element={<PolicyAdd />} />
              <Route
                path="policies/edit/:policyType"
                element={<PolicyEdit />}
              />
              <Route path="history" element={<History />} />
              <Route path="details" element={<Details />} />
              <Route path="ticket" element={<Ticket />} />
              <Route path="ticketview" element={<Ticketview />} />
              <Route path="products/media/:id" element={<ProductMedia />} />
              {/* <Route path="verification" element={<Verification />} /> */}
              <Route path="onlinehistory" element={<OnlineHistory />} />
              <Route path="document-type" element={<Documenttype />} />

              <Route path="openhistory" element={<OpenHistory />} />

              {/* <Route path="similarProducts" element={<SimilarProducts />} /> */}

              <Route path="customer" element={<CustomerPage />} />
              <Route path="control" element={<Rbackend />} />
              <Route path="allemployees" element={<AllEmployees />} />
              <Route path="00pass" element={<Pass00 />} />
              <Route path="storedetails" element={<StoreDetails />} />
              <Route path="storedetails/:id" element={<StoreDetails />} />
              {/* <Route path="socket-example" element={<SocketExample />} />
              <Route path="new1" element={<SocketExamplenew1 />} />
              <Route path="new2" element={<SocketExamplenew2 />} />
              <Route path="for1" element={<SocketExamplefor1 />} /> */}
              {/* <Route path="newChat" element={<newChat />} /> */}
              {/* <Route
                path="customer/edit/:customerId"
                element={<CustomerEditPage />}
              /> */}
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </NavigationScroll>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
